import React from "react";
import logosym from "../assets/logosym.png";

const Watermark = () => {
  return <img src={logosym} alt="watermark" className="app-watermark" />;
};

export default Watermark;